import React, { useState, useCallback } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Button, Spin } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

const PdfSlideshow = ({ url, autoPlay = false, interval = 5 }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);

  const onLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);

    if (autoPlay && numPages > 1) {
      const timer = setInterval(() => {
        setPageNumber(prev => (prev >= numPages ? 1 : prev + 1));
      }, interval * 1000);
      return () => clearInterval(timer);
    }
  }, [autoPlay, interval]);

  const prev = () => setPageNumber(p => Math.max(1, p - 1));
  const next = () => setPageNumber(p => Math.min(numPages, p + 1));

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {loading && <Spin style={{ margin: '60px 0' }} />}
      <Document
        file={url}
        onLoadSuccess={onLoadSuccess}
        onLoadError={() => setLoading(false)}
        loading={null}
      >
        <Page
          pageNumber={pageNumber}
          width={560}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>

      {numPages && numPages > 1 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
          <Button icon={<LeftOutlined />} onClick={prev} disabled={pageNumber <= 1} size="small" />
          <span style={{ fontSize: 13, color: '#666' }}>{pageNumber} / {numPages}</span>
          <Button icon={<RightOutlined />} onClick={next} disabled={pageNumber >= numPages} size="small" />
        </div>
      )}
    </div>
  );
};

export default PdfSlideshow;
